<template>
	<div class="card range-card ml-2 p-2 is-flex is-flex-wrap-wrap
		is-align-items-center">
		<div class="is-flex is-flex-wrap-wrap">
			<b-button v-for="option in options" :key="String(option.months)"
				class="m-1" :class="buttonClass(option.months)"
				:disabled="disabled"
				:id="option.months === 3 ? 'defaultMonthButton' : undefined"
				:aria-pressed="option.months === months ? 'true' : 'false'"
				@click="choose(option.months)">
				{{ option.label }}
			</b-button>
		</div>
		<b-input v-if="search" v-model="searchQuery" class="search"
			:placeholder="searchPlaceholder" icon="magnify" autocomplete="off"
			:size="isMobile ? 'is-small' : ''" :lazy="true"
			icon-right="close-circle" icon-right-clickable
			@icon-right-click="searchQuery = ''" />
	</div>
</template>

<script>
/**
 * The Alle/12/6/3-Monate range selector shared by the diary list, the
 * notifications and the chart views. Binds to the global chartMonths.
 */
export default {
	name: "MonthRangeButtons",
	props: {
		disabled: {
			type: Boolean,
			default: false,
		},
		search: {
			type: Boolean,
			default: false,
		},
		searchPlaceholder: {
			type: String,
			default: "Einträge suchen...",
		},
	},
	data() {
		return {
			options: [
				{ months: undefined, label: "Alle" },
				{ months: 12, label: "12 Monate" },
				{ months: 6, label: "6 Monate" },
				{ months: 3, label: "3 Monate" },
			],
		};
	},
	computed: {
		months() {
			return this.$store.getters.getChartMonths;
		},
		isMobile() {
			return this.$store.getters.isMobile;
		},
		searchQuery: {
			get() {
				return this.$store.state.entrySearchQuery;
			},
			set(query) {
				this.$store.dispatch("setEntrySearchQuery", query);
			},
		},
	},
	methods: {
		buttonClass(months) {
			const selection = months === this.months
				? "monthSelectionFocus" : "monthSelection";
			return this.isMobile ? selection + " is-small" : selection;
		},
		async choose(months) {
			await this.$store.dispatch("setChartMonths", months);
			this.$emit("change", months);
		},
	},
};
</script>

<style scoped>
/* Match the right inset of the entry rows below (their wrapper adds
   pr-1 on top of the 0.5em box margin). */
.range-card {
	margin-right: 0.75rem;
}

.search {
	/* Not the m-1 helper: its !important would beat the auto margin. */
	margin: 0.25rem 0.25rem 0.25rem auto;
	flex: 1 1 14rem;
	max-width: 24rem;
}

.search ::v-deep .input {
	border-radius: 6px;
}

.monthSelection {
	background-color: rgba(0, 0, 0, .4);
	color: white;
	margin-left: .1rem;
	border: 0px;
}

.monthSelection:hover {
	background-color: rgba(0, 0, 0, .6);
	color: white;
}

/* The selected range is the darkest one; it used to be the lightest,
   which read as the disabled state. */
.monthSelectionFocus {
	background-color: rgba(0, 0, 0, .85);
	margin-left: .1rem;
	color: white;
	border: 0px;
	box-shadow: none !important;
}

.monthSelectionFocus:focus {
	color: white;
	box-shadow: none !important;
}

.button[disabled] {
	background-color: rgba(0, 0, 0, .6);
	color: white;
}
</style>
